// This is a legacy location to keep the reexports test happy.
// Don't add anything new here.

export { cacheFor, guidFor } from './-internals';
